import { getEnumStringValue, SearchResultGroup_IconNameMap } from 'js/utils/enum-string-maps';

import ContentArea from 'components/content-area/ContentArea';
import Icon from 'components/icon/Icon';

import { ISearchResultGroup } from 'source/NFR.types';

const SearchResultGroup: React.FC<ISearchResultGroup> = ({ htmlId, results, title, iconName }) => {
  const iconStringName = getEnumStringValue(SearchResultGroup_IconNameMap, iconName);

  return (
    <div className="search-result-group">
      <div className="search-result-group--title" id={htmlId}>
        {title && <h2>{title}</h2>}
        {iconStringName && <Icon name={iconStringName} />}
      </div>
      <div className="search-result-group--items">
        <ContentArea
          additionalItemProps={{
            SearchResult: {
              theme: 'noMargin'
            },
            EmployeeSearchResult: {
              theme: 'noMargin'
            }
          }}
          additionalComponentProps={{
            SearchResult: {
              headingLevel: 2,
              theme: 'darkText'
            }
          }}
          {...results}
        />
      </div>
    </div>
  );
};

SearchResultGroup.displayName = 'SearchResultGroup';

export default SearchResultGroup;
